import type { FC, SVGProps } from 'react';

/**
 * The official Model Context Protocol (MCP) logo mark, inlined from the
 * project's brand asset (modelcontextprotocol/modelcontextprotocol
 * docs/logo/dark.svg — the mark only, wordmark dropped). Nominative use: it
 * marks records created or edited through the MCP connector.
 *
 * Interface mirrors react-feather icons (own <svg>, currentColor, 24×24 box)
 * so it drops into the same MUI <SvgIcon> wrappers the transaction-row icons
 * already use and inherits their color/size.
 */
const McpLogoIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 195 195"
    fill="none"
    stroke="currentColor"
    strokeWidth={14}
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    // Decorative by default: the meaning is carried by the button's aria-label
    // / tooltip, so the glyph must not announce itself separately. A caller
    // that uses it standalone can override aria-hidden and pass a title.
    aria-hidden="true"
    focusable={false}
    {...props}
  >
    <path d="M25 97.8528L92.8822 29.9706C102.255 20.598 117.451 20.598 126.823 29.9706V29.9706C136.196 39.3431 136.196 54.5391 126.823 63.9117L75.5581 115.177" />
    <path d="M76.2652 114.47L126.823 63.9117C136.196 54.5391 151.392 54.5391 160.765 63.9117L161.118 64.2652C170.491 73.6378 170.491 88.8338 161.118 98.2063L99.7248 159.6C96.6006 162.724 96.6006 167.789 99.7248 170.913L112.331 183.52" />
    <path d="M109.853 46.9411L59.6482 97.1457C50.2756 106.518 50.2756 121.714 59.6482 131.087V131.087C69.0208 140.459 84.2167 140.459 93.5893 131.087L143.794 80.8822" />
  </svg>
);

export default McpLogoIcon;
